<script>
export default {
    props: {
        fundSources: {
            type: Array,
            default: () => []
        },
        fsId: null
    },
    data(){
        return{
            series: [],
            series1: [0],
            series2: [0],
            series3: [0],
            chartOptions: {},
            plotOptions: {},
            fundSourceId: null
        }
    },
    methods: {
        setData(data){
            this.chartOptions = {
                series: [
                    { data: [data.totalProcurable, data.totalPr, data.totalPo, data.totalRfq] }
                ],
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: {
                        show: false,
                    }
                },
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val, opts) {
                        return val.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    },
                },
                tooltip: {
                    enabled: false,
                },
                xaxis: {
                    categories: ['Procurables', 'Purchase Requests', 'Purchase Orders', 'Request For Quotations'],
                }
            };
            this.series1 = [data.percentageOfPr.toFixed(2)];
            this.series2 = [data.percentageOfRfq.toFixed(2)];
            this.series3 = [data.percentageOfPo.toFixed(2)];
        },
        createChart(color, label){
            return {
                chart: {
                height: 200,
                type: "radialBar",
                offsetY: -10,
                },
                plotOptions: {
                radialBar: {
                    startAngle: -135,
                    endAngle: 135,
                    dataLabels: {
                    name: {
                        fontSize: "13px",
                        color: undefined,
                        offsetY: 60,
                    },
                    value: {
                        offsetY: 22,
                        fontSize: "16px",
                        color: undefined,
                        formatter: function (val) {
                        return val + "%";
                        },
                    },
                    },
                },
                },
                colors: [color],
                fill: {
                type: "gradient",
                gradient: {
                    shade: "dark",
                    shadeIntensity: 0.15,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 50, 65, 91],
                },
                },
                stroke: {
                    dashArray: 4,
                },
                labels: [label],
            }
        },
        changeFS(){
            this.$emit('change-fs', this.fundSourceId);
        }
    }
}
</script>
<template>
    <div class="card">
      <div class="card-body">
        <div class="d-sm-flex flex-wrap">
          <h4 class="card-title mb-2">Procurement Summary</h4>
        </div>
        <div>
            <label for="Fs">Select Fund Source:</label>
            <select class="form-select" v-model="fundSourceId" @change="changeFS">
                <option v-for="fs in fundSources" :key="fs.id" :value="fs.id">{{fs.sourceName}}</option>
            </select>
        </div>
        <div>
            <apexchart
                class="apex-charts"
                type="bar"
                dir="ltr"
                height="360"
                :series="series"
                :options="chartOptions"
            ></apexchart>
        </div>
        <div class="row">
            <div class="col-md-4 col-sm-12">
                <apexchart
                    class="apex-charts"
                    type="radialBar"
                    height="150"
                    dir="ltr"
                    :series="series1"
                    :options="createChart('#556ee6', 'Total PR Vs. Total Procurables')"
                ></apexchart>
            </div>
            <div class="col-md-4 col-sm-12">
                <apexchart
                    class="apex-charts"
                    type="radialBar"
                    height="150"
                    dir="ltr"
                    :series="series2"
                    :options="createChart('rgb(241, 180, 76)', 'Total RFQ Vs. Total PR')"
                ></apexchart>
            </div>
            <div class="col-md-4 col-sm-12 text-center">
                <apexchart
                    class="apex-charts"
                    type="radialBar"
                    height="150"
                    dir="ltr"
                    :series="series3"
                    :options="createChart('rgb(25, 135, 84)', 'Total Posted PO Vs. Total PR')"
                ></apexchart>
            </div>
        </div>
      </div>
    </div>
</template>